import { render, staticRenderFns } from "./HowItWorks.vue?vue&type=template&id=2d9c77d4&scoped=true&"
var script = {}
import style0 from "./HowItWorks.vue?vue&type=style&index=0&id=2d9c77d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9c77d4",
  null
  
)

export default component.exports